import React from 'react';
import { META_AD_TYPE } from '../SocialMediaConstant';

const InstagramFeedAd = ({
    image,
    message,
    buttonType,
}) => {
    const displayImage = image || 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=600&auto=format&fit=crop';

    return (
        <div style={{
            width: '100%',
            maxWidth: '340px',
            border: '1px solid #dee2e6',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            overflow: 'hidden',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            backgroundColor: '#ffffff',
        }}>
            {/* Instagram Header */}
            <div style={{
                display: 'flex', 
                alignItems: 'center', 
                padding: '12px', 
                borderBottom: '1px solid #f0f2f5'
            }}>
                <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '8px',
                    color: 'white',
                    fontSize: '1rem'
                }}>
                    <i className='fa fa-brands fa-instagram' />
                </div>
                <span style={{ fontSize: '0.8rem', fontWeight: '600', color: '#050505' }}>Instagram Feed</span>
            </div>

            {/* Profile Bar */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 12px',
            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src="https://bmsinfoglobal.com/wp-content/uploads/2023/05/bmslogo2.png"
                        alt="Logo"
                        style={{ 
                            width: '32px', 
                            height: '32px', 
                            borderRadius: '50%', 
                            marginRight: '10px',
                            border: '1px solid #e9ecef',
                            objectFit: 'contain',
                            backgroundColor: '#fff'
                        }}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontSize: '0.75rem', fontWeight: '700', color: '#262626' }}>brightmediasolution</span>
                        <span style={{ fontSize: '0.625rem', color: '#8e8e8e', marginTop: '1px' }}>Sponsored</span>
                    </div>
                </div>
                <button style={{ background: 'none', border: 'none', color: '#262626', cursor: 'pointer', padding: '4px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '1rem', letterSpacing: '1px' }}>•••</span>
                </button>
            </div>

            {/* Post Media */}
            <div style={{
                width: '100%',
                height: '240px',
                backgroundColor: '#fafafa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
            }}>
                <img
                    src={displayImage}
                    alt="Instagram Ad Content"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                    }}
                />
            </div>

            {/* Instagram CTA Bar (Prominent Banner right under image) */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#3897f0', // Classic Instagram CTA blue
                color: '#ffffff',
                padding: '10px 14px',
                cursor: 'pointer',
                transition: 'opacity 0.2s',
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = '0.9'}
            onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
            >
                <span style={{ fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {META_AD_TYPE[buttonType] || buttonType || 'Learn More'}
                </span>
                <i className='fa fa-chevron-right' style={{ fontSize: '0.7rem' }} />
            </div>

            {/* Icon Interactions */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 12px 6px 12px',
                fontSize: '1.1rem',
                color: '#262626',
            }}>
                <div style={{ display: 'flex', gap: '14px' }}>
                    <span style={{ cursor: 'pointer' }}><i className="fa fa-heart-o" /></span>
                    <span style={{ cursor: 'pointer' }}><i className="fa fa-comment-o" /></span>
                    <span style={{ cursor: 'pointer' }}><i className="fa fa-paper-plane-o" /></span>
                </div>
                <span style={{ cursor: 'pointer' }}><i className="fa fa-bookmark-o" /></span>
            </div>

            {/* Caption & Comments */}
            <div style={{ padding: '0 12px 12px 12px', fontSize: '0.775rem', lineHeight: '1.4' }}>
                <div style={{ color: '#262626', marginBottom: '4px' }}>
                    <span style={{ fontWeight: '700', marginRight: '6px' }}>brightmediasolution</span>
                    {message ? (
                        <span style={{ color: '#262626' }}>{message}</span>
                    ) : (
                        <span style={{ color: '#8e8e8e', fontStyle: 'italic' }}>Enter ad caption...</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InstagramFeedAd;
